import { Table, TableProps } from "rsuite";
import { PropsWithChildren } from "react";
import { HeaderCellProps } from "rsuite-table";

type WtaTableProps = {
  paginated?: boolean;
} & TableProps<any, any>;

const { HeaderCell } = Table;

export const EditableTable = ({
  children,
  virtualized,
  ...props
}: PropsWithChildren<WtaTableProps>) => {
  return (
    <Table virtualized={virtualized} fillHeight cellBordered {...props}>
      {children}
    </Table>
  );
};

export const WtaHeaderCell = (props: HeaderCellProps<any,any>) => (
  <HeaderCell {...props} className="wta-table-header-cell" />
);
